import { motion } from 'framer-motion';

/**
 * GlitchCardSkeleton — curator OS booting loader.
 * Scanning line + digital static → resolves into content.
 */
export function GlitchCardSkeleton({ height = 80, className = '' }) {
  return (
    <div
      className={`relative overflow-hidden border border-[#1a1a1a] bg-[#0d0d0d] ${className}`}
      style={{ height }}
    >
      {/* Static noise */}
      <div
        className="absolute inset-0 opacity-[0.07] mix-blend-screen"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, rgba(144,224,239,0.4) 0px, rgba(144,224,239,0.4) 1px, transparent 1px, transparent 3px)',
        }}
      />
      {/* Scan line */}
      <motion.div
        className="absolute left-0 right-0 h-[2px]"
        style={{
          background:
            'linear-gradient(90deg, transparent 0%, rgba(144,224,239,0.85) 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(144,224,239,0.65)',
        }}
        initial={{ top: 0 }}
        animate={{ top: ['0%', '100%', '0%'] }}
        transition={{ duration: 1.6, repeat: Infinity, ease: 'linear' }}
      />
      {/* Pulse block */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.03] to-transparent"
        animate={{ x: ['-100%', '100%'] }}
        transition={{ duration: 2.0, repeat: Infinity, ease: 'linear' }}
      />
      {/* Header bar placeholder */}
      <div className="absolute top-3 left-4 h-2 w-24 bg-[#1a1a1a]" />
      <div className="absolute top-8 left-4 h-4 w-32 bg-[#121212]" />
    </div>
  );
}

export function GlitchGrid({ count = 4, height = 90 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-px">
      {[...Array(count)].map((_, i) => (
        <GlitchCardSkeleton key={i} height={height} />
      ))}
    </div>
  );
}
